import { Button, Col, Descriptions, Row, Space } from 'antd';
import styled from 'styled-components';
import { styledDescriptions } from '../styled/mixin';
import Title from 'antd/lib/typography/Title';
import { AssetType, Expense } from '../../modules/expenses';
import moment from 'moment';
import {
  corporateNumberFormatter,
  getExpenseType,
  phoneFormatter,
  priceToString,
} from '../../util/utils';
import ExpenseHistoriesComponent from './ExpenseHistoriesComponent';

const StyledDiv = styled.div`
  ${styledDescriptions}
`;

interface ExpenseDetailComponentProps {
  expense: Expense;
  moveToEditPage?: () => void;
  onOpenPdfView: () => void;
  onOpenCreateExpenseCommentModal: () => void;
}

function ExpenseDetailComponent({
  expense,
  moveToEditPage,
  onOpenPdfView,
  onOpenCreateExpenseCommentModal,
}: ExpenseDetailComponentProps) {
  return (
    <StyledDiv>
      <Row justify="space-between" align="bottom">
        <Col>
          <Title level={3}>지출 상세</Title>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Descriptions
            title="지출정보"
            bordered
            column={2}
            size="small"
            style={{ marginTop: '10px' }}
            extra={
              <Space>
                {moveToEditPage && (
                  <Button size="small" onClick={moveToEditPage}>
                    수정하기
                  </Button>
                )}
              </Space>
            }
          >
            <Descriptions.Item label="합계 금액(원)">
              {priceToString(expense.price)}
            </Descriptions.Item>
            <Descriptions.Item label="부가세">
              {priceToString(expense.vat)}
            </Descriptions.Item>
            {!!expense.financialAssetInfo &&
              expense.financialAssetInfo.assetType === AssetType.CARD && (
                <Descriptions.Item label="카드정보">
                  {expense.financialAssetInfo.name} <br />(
                  {expense.financialAssetInfo.number})
                </Descriptions.Item>
              )}
            <Descriptions.Item label="업체명">
              {expense.companyName}
            </Descriptions.Item>
            <Descriptions.Item label="주소" span={2}>
              {expense.companyAddress}
            </Descriptions.Item>

            {!!expense.assetData && (
              <>
                <Descriptions.Item label="전화번호">
                  {phoneFormatter(expense.assetData.resMemberStoreTelNo, 1)}
                </Descriptions.Item>
                <Descriptions.Item label="사업자등록번호">
                  {corporateNumberFormatter(
                    expense.financialAssetInfo.assetType === AssetType.CARD
                      ? expense.assetData.resMemberStoreCorpNo
                      : expense.assetData.resSupplierRegNumber,
                  )}
                </Descriptions.Item>
              </>
            )}
            <Descriptions.Item label="사용일시">
              {expense.financialAssetInfo === null ||
              expense.financialAssetInfo.assetType === AssetType.CARD
                ? moment(expense.usedDateTime).format('YYYY-MM-DD HH:mm:ss')
                : moment(expense.usedDateTime).format('YYYY-MM-DD')}
            </Descriptions.Item>
            {
              <Descriptions.Item label="종류">
                {getExpenseType(expense)}
              </Descriptions.Item>
            }
            <Descriptions.Item label="공사종류">
              {expense.gongjong ? expense.gongjong : ''}
            </Descriptions.Item>
            <Descriptions.Item label="용도">
              {expense.category}
            </Descriptions.Item>
            <Descriptions.Item label="프로젝트">
              {expense.project ? expense.project.name : ''}
            </Descriptions.Item>
            <Descriptions.Item label="사용자">
              {expense.usedBy ? expense.usedBy.name : ''}
            </Descriptions.Item>
            <Descriptions.Item label="경비환급">
              {expense.isRefund ? '예' : '아니오'}
            </Descriptions.Item>
            <Descriptions.Item label="설명" style={{ whiteSpace: 'pre-wrap' }}>
              {expense.description}
            </Descriptions.Item>
            <Descriptions.Item label="첨부파일">
              <Button
                size="small"
                onClick={onOpenPdfView}
                disabled={expense.file.length === 0}
              >
                첨부파일 보기
              </Button>
            </Descriptions.Item>
          </Descriptions>
        </Col>
      </Row>
      <div style={{ marginTop: '30px' }}>
        <ExpenseHistoriesComponent
          expenseHistories={expense.expenseHistories}
          onOpenCreateExpenseCommentModal={onOpenCreateExpenseCommentModal}
        />
      </div>
    </StyledDiv>
  );
}
export default ExpenseDetailComponent;
